/**
 * UUID utility functions for generating temporary material IDs
 * Used for coordinating parent-child relationships between frontend and backend
 */

import UUID from 'uuidjs';

/**
 * Generate a temporary material ID for new SDS Section 3 materials
 * Used when creating new materials that don't have database IDs yet
 * @returns {string} Temporary material UUID
 */
export const generateTempMaterialId = (): string => {
  return `temp-material-${UUID.generate()}`;
};

/**
 * Generate a temporary impurity material ID for new SDS Section 3 impurity materials
 * Used when creating new impurity materials that don't have database IDs yet
 * @returns {string} Temporary impurity material UUID
 */
export const generateTempImpurityId = (): string => {
  return `temp-impurity-${UUID.generate()}`;
};
